import React from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import ImageLoader from '../../Image';

const Avatar = (props) => (
  <ImageLoader
    src={props.source || '/images/default-avatar.png'}
    alt="avatar"
    objectFit="cover"
    width={props.size || ''}
    height={props.size || ''}
    style={{
      ...props.style,
    }}
    className={`avatar-view ${props.className ? props.className : ''}`}
  />
);
Avatar.propTypes = {
  source: PropTypes.any,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default Avatar;
